// Debug
// const dropsFilesUrl = "./";
const dropsFilesUrl = "https://sygnialabs.github.io/DROPS-Tools/";
export {dropsFilesUrl};